import { useTranslation } from 'react-i18next'
import { BackToPrevPageLink } from '@/feature/fundraising-advisory/components/BackToPrevPageLink.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { ScrollableRouteContainer } from '@/components/shared/Container.tsx'
import { PageBody, PageHeader } from '@/components/shared/page-sections.tsx'

export const ContentSkeleton = () => (
  <>
    <Skeleton className='h-[106px] rounded-xl' />
    <Skeleton className='h-[256px] rounded-xl' />
  </>
)
export const FundingHistoryPageSkeleton = () => {
  const { t } = useTranslation(`fundraising`)
  return (
    <ScrollableRouteContainer className={`p-0`}>
      <PageHeader className={`flex flex-col gap-6`}>
        <BackToPrevPageLink to={`..`} className={`self-start`}>
          {t(`fundraising.navigation.back_to_index`)}
        </BackToPrevPageLink>
        <div className={`flex items-center justify-between`}>
          <div className={`flex flex-col gap-1 px-2`}>
            <h1 className={`text-2xl font-semibold text-primary`}>{t(`fundraising.funding_history.index.title`)}</h1>
            <h3 className={`text-base font-normal text-secondary`}>{t(`fundraising.funding_history.index.subtitle`)}</h3>
          </div>
        </div>
      </PageHeader>
      <PageBody>
        <ContentSkeleton />
      </PageBody>
    </ScrollableRouteContainer>
  )
}
